import { createFileRoute } from "@tanstack/react-router";
import AdminSeedDataPage from "@/admin/pages/seed-data";

export const Route = createFileRoute("/admin/seed-data/")({
  component: AdminSeedDataPage,
});
